import { apiVersion } from './apis.const';
import { transformResponse } from './apis.util';
import { baseApi } from './base.api';

/**
 * API Urls
 */
const userUrl = `/${apiVersion}/user`;
const userProfileUrl = `/${apiVersion}/user/profile-photo`;

/**
 * Create APIs
 */
export const userApi = baseApi.injectEndpoints({
  overrideExisting: false,

  endpoints: (build) => ({
    fetchUser: build.query<FetchUserRes, FetchUserReq>({
      query: () => ({
        url: userUrl,
      }),
      transformResponse,
      providesTags: ['CurrentUser'],
    }),

    updateUser: build.mutation<UpdateUserRes, UpdateUserReq>({
      query: ({ user, new_password, old_password }) => ({
        url: userUrl,
        method: 'PUT',
        body: { user, new_password, old_password },
      }),
      transformResponse,
      invalidatesTags: ['CurrentUser'],
    }),

    addProfileImage: build.mutation<AddProfileImageRes, AddProfileImageReq>({
      query: ({ data }) => ({
        url: userProfileUrl,
        method: 'POST',
        body: data,
      }),
      transformResponse,
    }),

    deleteProfileImage: build.mutation<DeleteProfileProfileRes, DeleteProfileImageReq>({
      query: () => ({
        url: userProfileUrl,
        method: 'DELETE',
      }),
      transformResponse,
    }),
  }),
});

/**
 * Hooks
 */
export const { useFetchUserQuery, useUpdateUserMutation, useAddProfileImageMutation, useDeleteProfileImageMutation } =
  userApi;

/**
 * Types
 */
export type FetchUserRes = any;
type FetchUserReq = void;
type UpdateUserRes = any;
type UpdateUserReq = {
  user: any;
  new_password?: string;
  old_password?: string;
};
type AddProfileImageRes = any;
type AddProfileImageReq = {
  data: FormData;
};
type DeleteProfileProfileRes = any;
type DeleteProfileImageReq = undefined;
